var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{ref:"inputRef",class:(('form-control text-right') + " " + _vm.className),attrs:{"autocomplete":_vm.autocomplete}})}
var staticRenderFns = []

export { render, staticRenderFns }